module.exports = __webpack_public_path__ + "img/main-icn-04.30090763.svg";